import { SubDomain } from '@/router/index'

export enum Broker {
  Yago = 'Yago',
  Stroobants = 'Stroobants'
}

export enum BrokerPlatform {
  Yago = 'MyYago',
  Stroobants = 'MyStroobants'
}

export enum BrokerKey {
  Yago = 'yago',
  Stroobants = 'stroobants'
}

export const brokerIsStroobants = () => {
  return !!window.location.href.includes(SubDomain.Stroobants)
}

export const brokerName = () => {
  if (brokerIsStroobants()) return Broker.Stroobants
  else return Broker.Yago
}

export const brokerPlatformName = () => {
  if (brokerIsStroobants()) return BrokerPlatform.Stroobants
  else return BrokerPlatform.Yago
}

export const broker = () => {
  if (brokerIsStroobants()) return BrokerKey.Stroobants
  else return BrokerKey.Yago
}

export const brokerTel = (isCompanyProfile?: boolean, hasB2bPca?: boolean) => {
  // stroobants
  if (brokerIsStroobants()) return '+32 2 374 32 22'
  // yago b2b
  else if (isCompanyProfile && hasB2bPca) return `+32 2 588 41 65`
  // yago independent
  else if (isCompanyProfile && !hasB2bPca) return `+32 2 586 02 44`
  // yago particular
  else return '+32 2 808 11 78'
}
